module.exports = __webpack_public_path__ + "static/img/2-12-普通补发填写.00b303f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-12-普通补发填写.png
// module id = 1347
// module chunks = 0